import { create } from "zustand";
import type { FeedbackImage } from "./feedback.js";

interface FeedbackOpenOptions {
  image?: FeedbackImage | undefined;
  source?: string | undefined;
  note?: string | undefined;
}

interface FeedbackState {
  open: boolean;
  image?: FeedbackImage | undefined;
  source?: string | undefined;
  note: string;
  openFeedback: (options?: FeedbackOpenOptions) => void;
  closeFeedback: () => void;
}

export const useFeedbackStore = create<FeedbackState>((set) => ({
  open: false,
  image: undefined,
  source: undefined,
  note: "",
  openFeedback: (options) => set({
    open: true,
    image: options?.image,
    source: options?.source,
    note: options?.note ?? "",
  }),
  closeFeedback: () => set({ open: false, image: undefined, source: undefined, note: "" }),
}));
